import { sendGAEvent } from '@next/third-parties/google';

const googleEventShare = (itemId: string): any => {
  return sendGAEvent('event', 'share', {
    itemId: itemId,
  });
};

export default googleEventShare;
